import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Fetch All Users
export const fetchUsers = createAsyncThunk("users/fetchAll", async () => {
  const response = await axios.get(`${BASE_URL}/api/users`);
  return response.data;
});

// 🔹 Add a New User
export const addUser = createAsyncThunk("users/add", async (userData, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${BASE_URL}/api/users`, userData, {
      headers: { Authorization: `Bearer ${token}`, credentials: "include", withCredentials: true },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Update a User
export const updateUser = createAsyncThunk("users/update", async ({ id, userData }, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${BASE_URL}/api/users/${id}`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Delete a User
export const deleteUser = createAsyncThunk("users/delete", async (id, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    await axios.delete(`${BASE_URL}/api/users/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return id;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 User Slice
const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.users.push(action.payload);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.users = state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        );
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter((user) => user._id !== action.payload);
      });
  },
});

export default userSlice.reducer;
